import { JSX } from 'react';
import { MultiColumnCta } from '@ahc-digital/component-library';
import { CreateMultiColumnCTAsModel } from './C05MulticolumnCTAs.service';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';
import { C05MulticolumnCTAsProps } from './C05MutlicolumnCTAs.types';

const Default = (props?: C05MulticolumnCTAsProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return (
    <MultiColumnCta
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      {...CreateMultiColumnCTAsModel(props)}
    />
  );
};

export default checkDatasourceForRendering<C05MulticolumnCTAsProps>(Default);
